import noResult from './noResult'

const autocompleteHits = (itemComponent) => {
  return ({ hits, sendEvent, widgetParams }) => {
    const container = widgetParams.container

    container.innerHTML = `
    <ul class="autocomplete-list">
      ${
        hits.length
          ? hits.map((item) => itemComponent(item)).join('')
          : noResult
      }
    </ul>
  `

  container
    .querySelectorAll('.algolia-autocomplete-products-handler .feed-autocomplete')
    .forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Product Clicked')
      })
    })

  container
    .querySelectorAll('.algolia-autocomplete-recipes-handler .feed-autocomplete')
    .forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Recipe Clicked')
      })
    })

  container
    .querySelectorAll('.algolia-autocomplete-recipes-handler .feed-autocomplete')
    .forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'FAQ Clicked')
      })
    })

  }
}

export default autocompleteHits
